/** テンプレートプレビュー用デモ施設は dev 環境 DB にのみ存在する */
const DEMO_HOTEL_PREVIEW_GUEST_DOMAIN = "https://dev-guest.chillnn.com";

export const generatePreviewUrl = (hotelID: string) => {
	return `${DEMO_HOTEL_PREVIEW_GUEST_DOMAIN}/${hotelID}`;
};
